/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable no-unused-expressions */


function handleInitialAdjustments(questionnaire) {

  questionnaire = questionnaire.map((question) => {
    if (question.idQuestion === 1943 && (question.idAnswerOption === 7594 || question.visibleQuestion === 0)) {
      questionnaire = questionnaire.map((qst) => {
        if (qst.idQuestion === 1961) {
          qst.visibleQuestion = 0;
        }
        return qst;
      })
    }

    if (question.idQuestion === 1961) {
      if (question.answer !== '' && JSON.parse(question.answer).length > 0) {
        question.hiddenInput = true;
      }
    }

    return question
  })

  
  return questionnaire;
}

function handleQuestionChange({
  question,
  value,
  questionnaireUpdated,
  setQuestionnaire,
  setFieldValue,
  questionnaireAnswersToDelete,
  setQuestionnaireAnswersToDelete,
  documentsToDelete,
  setDocumentsToDelete
}) {
  try {
    let saveQuestionnaire = false;

    const newQuestionnaireAnswersToDelete = []
    const newDocumentsToDelete = []

    if (question.idQuestion === 1961) {
      saveQuestionnaire = true;

      if (!Array.isArray(value)) {
        const attachment = question?.answer?.length ? question?.answer[0] : null;
        if (attachment) {
          newDocumentsToDelete.push(attachment.documentId)
        }
      } else {
        if (question.idQuestionnaireAnswers) {
          setQuestionnaireAnswersToDelete([
            ...questionnaireAnswersToDelete
              .filter((idQuestionnaireAnswers) => idQuestionnaireAnswers !== question.idQuestionnaireAnswers),
          ])
        }
      }

      questionnaireUpdated = questionnaireUpdated.map((qst) => {
        if (qst.key === question.key) {
          qst.hiddenInput = value.length;
          qst.answer = qst.answerJson = value?.length ? value : []
          setFieldValue(qst.key, value?.length ? value : [])
        }
        return qst;
      })
    }

    if (newQuestionnaireAnswersToDelete.length) {
      setQuestionnaireAnswersToDelete([
        ...questionnaireAnswersToDelete,
        ...newQuestionnaireAnswersToDelete
          .filter((idQuestionnaireAnswers) => idQuestionnaireAnswers)
          .filter((idQuestionnaireAnswers) => !questionnaireAnswersToDelete.includes(idQuestionnaireAnswers))
      ]);
    }

    if (newDocumentsToDelete.length) {
      setDocumentsToDelete([
        ...documentsToDelete,
        ...newDocumentsToDelete
          .filter((documentId) => !documentsToDelete.includes(documentId))
      ]);
    }

    if (saveQuestionnaire) setQuestionnaire(questionnaireUpdated)
  } catch (e) {
    console.log('MRC1_ATTACHMENTS - handleQuestionChange - error', e);
  }
}

const events = {
  handleInitialAdjustments,
  handleQuestionChange
};

export { events };